'use client'

import { Toaster as Sonner, type ToasterProps } from 'sonner'

/** Toaster único dos apps. Os toasts em si continuam vindo de `toast()` do
 *  sonner; aqui só fica a aparência padrão (cores ricas por tipo). */
const Toaster = (props: ToasterProps) => {
  return <Sonner richColors className="toaster group" {...props} />
}

export { Toaster }
